import { createAction, createReducer } from '@reduxjs/toolkit';
import type { Pixel } from 'types/actions/tracking';

export const createPixel = createAction<Pixel, 'createPixel'>('createPixel');

type Init = {
  pixels: string[];
}

const init: Init = {
  pixels: [],
};

export const trackingReducer = createReducer(init, (builder) =>
  builder.addCase(createPixel, (state, { payload }) => {
    if (state?.pixels?.includes(payload.src)) return state;

    return {
      ...state,
      pixels: [...state.pixels, payload.src],
    };
  })
);
